import { render, staticRenderFns } from "./ricerca.vue?vue&type=template&id=1b84d86d&scoped=true&"
import script from "./ricerca.vue?vue&type=script&lang=js&"
export * from "./ricerca.vue?vue&type=script&lang=js&"
import style0 from "./ricerca.vue?vue&type=style&index=0&id=1b84d86d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b84d86d",
  null
  
)

export default component.exports